import { generatePath } from '@toggle/helpers';
import { useNavigate } from 'react-router';

import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { appPaths, queryKeys } from '~/routes/app-paths';
import { create } from '~/utils/store/createStore';

const modes = ['quickAnalysis', 'document', 'research'] as const;
export type ChatMode = typeof modes[number];

export const DEEP_RESEARCH_QUERY_PARAM = 'research';

type ChatModeStore = {
  chatMode: ChatMode;
  setChatMode: (chatMode: ChatMode) => void;
};

const useChatModeStore = create<ChatModeStore>(set => ({
  chatMode: 'research',
  setChatMode: chatMode => set({ chatMode }),
}));

export const useChatNavigation = () => {
  const { chatMode, setChatMode } = useChatModeStore();
  const { params, setQueryParams } = useQueryParams();
  const navigate = useNavigate();

  const navigateToAlfred = (
    mode: ChatMode,
    searchParams = new URLSearchParams()
  ) => {
    setMode(mode);

    navigate({
      pathname: appPaths.alfred,
      search: searchParams.toString(),
    });
  };

  const setMode = (mode: ChatMode) => {
    const onAlfredPage = appPaths.alfred === location.pathname;

    if (onAlfredPage) {
      setQueryParams({ [queryKeys.mode]: mode }, { replace: true });
    }

    setChatMode(mode);
  };

  const navigateToConversation = (conversationId: string, newTab = false) => {
    const url = generatePath({
      basePath: appPaths.alfred,
      params: {
        [queryKeys.mode]: DEEP_RESEARCH_QUERY_PARAM,
        [queryKeys.conversationId]: conversationId,
      },
    });

    if (newTab) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }

    navigate(url);
  };

  return {
    navigateToAlfred,
    mode: (params?.[queryKeys.mode] as ChatMode) || chatMode,
    setMode,
    navigateToConversation,
  };
};
